export const FETCH_PROFILE_PENDING = "FETCH_PROFILE_PENDING";

export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";

export const FETCH_PROFILE_ERROR = "FETCH_PROFILE_ERROR";
